import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import useStyles from '../styles'

export const labelIdFor = id => `${id}-label`
export const helperIdFor = id => `${id}-helper`

// One filter: a title, an optional line saying what it matches, then the
// control. Every control in Filter mode uses this so they read the same.
export default function FilterField({
  id,
  label,
  description,
  role,
  children,
}) {
  const classes = useStyles()

  return (
    <Box role={role} aria-labelledby={role ? labelIdFor(id) : undefined}>
      <Typography id={labelIdFor(id)} className={classes.fieldLabel}>
        {label}
      </Typography>
      {description ? (
        <Typography id={helperIdFor(id)} className={classes.helperText}>
          {description}
        </Typography>
      ) : null}
      <Box className={classes.fieldControl}>{children}</Box>
    </Box>
  )
}

FilterField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  role: PropTypes.string,
  children: PropTypes.node,
}

// A select named by the title above it and described by the line under it.
export function FilterSelect({
  id,
  label,
  description,
  value,
  options,
  onChange,
  children,
}) {
  return (
    <FilterField id={id} label={label} description={description}>
      <TextField
        id={id}
        select
        variant="outlined"
        value={value}
        onChange={event => onChange(event.target.value)}
        SelectProps={{
          labelId: labelIdFor(id),
          SelectDisplayProps: description
            ? { 'aria-describedby': helperIdFor(id) }
            : undefined,
        }}
        fullWidth
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      {children}
    </FilterField>
  )
}

FilterSelect.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node,
}
